import vue from "vue";
import ApiService from "@/common/ApiService";
import urlConfig from "@/../public/urlConfig.json";
const apiService = new ApiService(vue.prototype.$config.dolphinBaseAddress);

export default ({
  state: {
    selectedReserve: {},
    customerInfo: {},
    bookingData: {},
  },

  mutations: {

  },

  getters: {

  },

  actions: {

    async getProductServicesDolphin(context, providerId) {
      try {
        const response = await apiService.Get("/product/GetProducts?providerId=" + providerId)

        return response.data;
      } catch (error) {
        console.log(error);
      }
    },


    async checkAvailabilityDolphin(context, data) {
      try {
        const response = await apiService.Post("/Availability/CheckAvailability", data);
        return response;

      } catch (err) {
        console.log(err);
      }

    },

    async getIPGsDolphin(context, data) {
      try {
        const response = await apiService.Post("/IPG/GetIPGs", data);
        return response.data;

      } catch (err) {
        console.log(err);
      }

    },
    async reserveTourismDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/Book", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }

    },
    async depositBookingDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/DepositBooking", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }

    },
    async tourismBookingDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/payment", data);

        return response.data.data;

      } catch (err) {
        console.log(err);
      }
    },
    async confirmBookingDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/ConfirmBooking", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },
    async confirmBookingV2Dolphin (context, data) {
      try {
        const response = await apiService.Post("/Booking/confirmBookingV2", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },
    async getBookingDetailDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/getbyIdNew", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },
    async getByVoucherDolphin(context, voucherNumber) {
      try {
        const response = await apiService.Post("/Booking/getByVoucherNew", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },

    ///cancel reservation

    async getCancelreasonDolphin(context) {
      try {
        const response = await apiService.Get("/cancelreason/get");

        return response;

      } catch (err) {
        console.log(err);
      }
    },


    async getBookingListForCancelDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/getBookingListForCancel", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },

    async bookingCancelDolphin(context, data) {
      try {
        const response = await apiService.Post("/booking/Cancel", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },

    async getBookingItemForEditDolphin(context, data) {
      try {
        const response = await apiService.Post("/booking/getBookingItemForEdit", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },

    async editFastTrackInfoDolphin(context, data) {
      try {
        const response = await apiService.Post("/Booking/edit", data);

        return response.data;

      } catch (err) {
        console.log(err);
      }
    },
    async increaseDepositDolphin(context, data) {
      try {
        const response = await apiService.Post("/Source/IncreaseDeposit", data);

        return response;

      } catch (err) {
        console.log(err);
      }
    },

  }

});